import { encryptdata } from "../../../utils/encryptDecrypt";
import { getApi} from "../api";


export const viewSubtranctionApi = ()=> getApi(`masters/usersubscription/userplan/${encryptdata(localStorage.getItem('userId'))}?status=paid`)